import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { useLang } from "@/lib/i18n";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const UNIT_OPTIONS = [
  { value: "KG", label: "KG" },
  { value: "MT", label: "Metric Ton" },
  { value: "TRUCK", label: "Truck" },
];

export function unitLabel(u) {
  if (u === "MT") return "Metric Ton";
  if (u === "TRUCK") return "Truck";
  return u || "MT";
}

export function inr(n) {
  if (n === null || n === undefined || n === "") return "";
  return "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}

export function fmtDateTime(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return d;
  }
}

export function toMt(qty, unit, truckCap) {
  const q = Number(qty) || 0;
  if (unit === "KG") return q / 1000;
  if (unit === "TRUCK") return q * (Number(truckCap) || 7);
  return q;
}

const BADGE = {
  "Order Placed": "bg-amber-50 text-amber-800 border-amber-200",
  "Under Review": "bg-amber-50 text-amber-800 border-amber-200",
  "Pending Approval": "bg-amber-50 text-amber-800 border-amber-200",
  "Quantity Modified": "bg-blue-50 text-blue-800 border-blue-200",
  Confirmed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Payment Pending": "bg-amber-50 text-amber-800 border-amber-200",
  "Payment Completed": "bg-blue-50 text-blue-800 border-blue-200",
  "Preparing for Delivery": "bg-indigo-50 text-indigo-800 border-indigo-200",
  "Out for Delivery": "bg-indigo-50 text-indigo-800 border-indigo-200",
  Delivered: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Cancelled: "bg-rose-50 text-rose-800 border-rose-200",
  Completed: "bg-slate-100 text-slate-800 border-slate-300",
  Pending: "bg-amber-50 text-amber-800 border-amber-200",
  Approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Requested: "bg-slate-50 text-slate-700 border-slate-200",
  Modified: "bg-blue-50 text-blue-800 border-blue-200",
  "Partially Paid": "bg-blue-50 text-blue-800 border-blue-200",
  Paid: "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Rate Pending": "bg-slate-100 text-slate-700 border-slate-300",
  "Ready for Dispatch": "bg-indigo-50 text-indigo-800 border-indigo-200",
  Dispatched: "bg-indigo-50 text-indigo-800 border-indigo-200",
  verified: "bg-emerald-50 text-emerald-800 border-emerald-200",
  pending: "bg-amber-50 text-amber-800 border-amber-200",
};

export function badgeClass(status) {
  return BADGE[status] || "bg-slate-50 text-slate-700 border-slate-200";
}

export function StatusBadge({ status, testid }) {
  const { tAny } = useLang();
  return (
    <span
      data-testid={testid || `status-badge-${String(status).toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${badgeClass(status)}`}
    >
      {tAny(status)}
    </span>
  );
}
